<template>
  <IndexForm :is-whitelabel="isWhitelabel">
    <PublisherRegistrationPageForm
      v-if="prpDetails"
      :action-status="actionStatus"
      :prp-details="prpDetails"
      @on-register="onSubmit"
    />
    <OpenRegistrationPageError
      v-if="!prpDetails"
      :applicant-type="'publisher'"
    />
  </IndexForm>
</template>

<script>

import messages from '../../locales';
import PublisherRegistrationPageForm from './PublisherRegistrationPageForm';
import OpenRegistrationPageError from '@/modules/auth/components/OpenRegistrationPage/OpenRegistrationPageError';
import IndexForm from '@/modules/auth/components/OpenRegistrationPage/IndexForm';
import { mapState, mapActions } from 'vuex';
import { getStatus } from '@/store/helpers';

export default {
  components: { PublisherRegistrationPageForm, OpenRegistrationPageError, IndexForm },
  props: {
    isWhitelabel: {
      type: Boolean,
      default() {
        return true;
      },
    },
    prpDetails: {
      type: Object,
      default() {
        return {};
      },
    },
    prpId: {
      type: String,
      default() {
        return '';
      },
    },
  },
  computed: {
    ...mapState('auth', {
      actionStatus: (state) => getStatus(state, 'sendPRPRequest')
    })
  },
  methods: {
    ...mapActions('auth', ['sendPRPRequest']),
    onSubmit(requestData) {
      this.sendPRPRequest({prpId: this.prpId, requestData});
    },
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style>

</style>